import React, { useState } from 'react';
import { SanityNewsletterSection } from 'graphql-types';
import * as styles from './newsletterSection.module.scss';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Field, Form } from 'react-final-form';
import { Input } from '../html-tag/Input';
import { usePageContext } from '../context/pageContext';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import { Blocks } from '../ui/blocks/Blocks';
import { Button } from '../html-tag/Button';
import { gtagSendEvent } from '../../utils/sendGtagEvent';
import { findTranslation } from '../../utils/findTranslation';

interface Props {
  section: SanityNewsletterSection;
}

export interface newsletterDATA {
  email: string;
}

export const NewsletterSection: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();
  const [popUp, setPopUp] = useState<boolean>(false);
  const onSubmit = (values: any, form) => {
    const email = values.email;

    addToMailchimp(email);
    setPopUp(true);
    form.restart();
    form.reset();
  };

  const required = (values: string) => (values ? undefined : 'This field has a error');

  return (
    <div className={styles.wrapper}>
      <div className={styles.image}>
        <GatsbyImage
          alt={section?.imgBgNewsletter?.alt ?? ''}
          image={section?.imgBgNewsletter?.img?.asset?.gatsbyImageData}
        />
        <div className={styles.overlay} />
        <Form
          onSubmit={onSubmit}
          render={({ handleSubmit, form }) => {
            return (
              <div className={styles.content}>
                <div className={styles.form}>
                  <form
                    onSubmit={handleSubmit}
                    className={styles.form}
                  >
                    <fieldset>
                      <div>
                        <Field
                          name="email"
                          component={Input}
                          label={findTranslation(
                            section?.newsletterBlockSection?._rawNewsletterCta,
                            lang,
                            defaultLang,
                          )}
                          placeholder={findTranslation(
                            section?.newsletterBlockSection?._rawEmailPlaceholder,
                            lang,
                            defaultLang,
                          )}
                          type="email"
                          id="mce-EMAIL"
                          validate={required}
                        ></Field>

                        <Field
                          name="optin"
                          component="input"
                          validate={required}
                        >
                          {({ input, meta }) => (
                            <div className={styles.wrapperCheckbox}>
                              <div
                                className={`${styles.checkbox} ${
                                  meta.error && meta.touched && styles.checkboxW
                                }`}
                              >
                                <input
                                  {...input}
                                  type="checkbox"
                                  value="checked"
                                  className={styles.optin}
                                />
                              </div>

                              <label className={`${meta.error && meta.touched && styles.labelW}`}>
                                {findTranslation(
                                  section?._rawNewsletterOptinSection,
                                  lang,
                                  defaultLang,
                                )}
                              </label>
                            </div>
                          )}
                        </Field>
                        <div className={styles.button}>
                          <Button
                            label={findTranslation(
                              section?.newsletterBlockSection?._rawNewsletterButton,
                              lang,
                              defaultLang,
                            )}
                            type={'submit'}
                            onClick={() => gtagSendEvent('register', 'newsletter')}
                            dataType={'multiwhite'}
                          />
                          {popUp && (
                            <Blocks
                              blocks={findTranslation(
                                section?._rawNewsletterConfirmationSection,
                                lang,
                                defaultLang,
                              )}
                            />
                          )}
                        </div>
                      </div>
                      <h4 className={styles.warning}>
                        {findTranslation(
                          section?._rawNewsletterWarningTextSection,
                          lang,
                          defaultLang,
                        )}
                      </h4>
                    </fieldset>
                  </form>
                </div>
              </div>
            );
          }}
        />
      </div>
      <div className={styles.imageDesktop}>
        <GatsbyImage
          alt={section?.imgBgNewsletter?.alt ?? ''}
          image={section?.imgBgNewsletter?.img?.asset?.gatsbyImageData}
        />
        <div className={styles.overlay} />
        <Form
          onSubmit={onSubmit}
          render={({ handleSubmit, form }) => {
            return (
              <div className={styles.content}>
                <div className={styles.form}>
                  <form
                    onSubmit={handleSubmit}
                    className={styles.form}
                  >
                    <fieldset>
                      <div>
                        <Field
                          name="email"
                          component={Input}
                          label={findTranslation(
                            section?.newsletterBlockSection?._rawNewsletterCta,
                            lang,
                            defaultLang,
                          )}
                          placeholder={findTranslation(
                            section?.newsletterBlockSection?._rawEmailPlaceholder,
                            lang,
                            defaultLang,
                          )}
                          validate={required}
                          type="email"
                          id="mce-EMAIL"
                        ></Field>

                        <Field
                          name="optin"
                          component="input"
                          validate={required}
                        >
                          {({ input, meta }) => (
                            <div className={styles.wrapperCheckbox}>
                              <div
                                className={`${styles.checkbox} ${
                                  meta.error && meta.touched && styles.checkboxW
                                }`}
                              >
                                <input
                                  {...input}
                                  type="checkbox"
                                  value="checked"
                                  className={styles.optin}
                                />
                              </div>

                              <label className={`${meta.error && meta.touched && styles.labelW}`}>
                                {findTranslation(
                                  section?._rawNewsletterOptinSection,
                                  lang,
                                  defaultLang,
                                )}
                              </label>
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className={styles.button}>
                        <Button
                          label={findTranslation(
                            section?.newsletterBlockSection?._rawNewsletterButton,
                            lang,
                            defaultLang,
                          )}
                          type={'submit'}
                          onClick={() => {}}
                          dataType={'multiwhite'}
                        />
                        {popUp && (
                          <Blocks
                            blocks={findTranslation(
                              section?._rawNewsletterConfirmationSection,
                              lang,
                              defaultLang,
                            )}
                          />
                        )}
                      </div>
                      <h4 className={styles.warning}>
                        {findTranslation(
                          section?._rawNewsletterWarningTextSection,
                          lang,
                          defaultLang,
                        )}
                      </h4>
                    </fieldset>
                  </form>
                </div>
              </div>
            );
          }}
        />
      </div>
      <div className={styles.footer}>
        <Blocks
          blocks={findTranslation(section?._rawNewsletterThankYouTextSection, lang, defaultLang)}
        />
        <div className={styles.contacts}>
          {section?.addressList?.map((contact, index) => {
            return (
              <div
                className={styles.contact}
                key={`contact-${index}`}
              >
                <h4 className={styles.name}>{contact?.contactName}</h4>
                <h4>{contact?.contactAddress}</h4>
                <h4 className={styles.email}> {contact?.contactEmail}</h4>
                <h4>{contact?.contactPhone}</h4>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
